"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "randomString", {
  enumerable: true,
  get: function get() {
    return _randomString["default"];
  }
});

var _randomString = _interopRequireDefault(require("./randomString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }